import {
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  EDIT_PROFILE,
  RESET_PROFILE_FLAG,
  EDIT_COMPANY,
  EDIT_COMPANY_SUCCESS,
  EDIT_COMPANY_ERROR,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_ERROR,
  LOCATION_LIST_SUCCESS,
  LOCATION_LIST_ERROR,
  MANAGER_LIST_SUCCESS,
  MANAGER_LIST_ERROR,
  ASSIGN_LOCATION_SUCCESS,
  ASSIGN_LOCATION_ERROR,
  GET_MANAGER_BY_ID_SUCCESS,
  GET_MANAGER_BY_ID_ERROR,
  GET_EMPLOYEE_BY_LOCATION_SUCCESS,
  GET_EMPLOYEE_BY_LOCATION_ERROR,
  UPDATE_MANAGER_DETAILS_SUCCESS,
  UPDATE_MANAGER_DETAILS_ERROR,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_ERROR,
  LOGIN_AS_MANAGER_SUCCESS,
  LOGIN_AS_MANAGER_ERROR,
  LOGIN_AS_ADMIN_SUCCESS,
  LOGIN_AS_ADMIN_ERROR,
  AVAILABLE_LOCATIONS_SUCCESS,
  AVAILABLE_LOCATIONS_ERROR,
  SKIP_LOCATION_SUCCESS,
  SKIP_LOCATION_ERROR,
  GET_PARTICIPANT_BY_LOCATION_SUCCESS,
  GET_PARTICIPANT_BY_LOCATION_ERROR,
  NOTIFICATION_SUCCESS,
  NOTIFICATION_ERROR,
  FREE_NOTIFICATION_SUCCESS,
  FREE_NOTIFICATION_ERROR,
  GET_USER_DATA_SUCCESS,
  ADD_ADMIN_SWITCH_ACCOUNT_SUCCESS,
  ADD_ADMIN_SWITCH_ACCOUNT_FAIL,
} from "./actionTypes";

const initialState = {
  me: {},
  error: "",
  success: "",
  response: [],
  locationsList: [],
  locationList: [],
  managerList: [],
  assignRes: [],
  managerDetails: [],
  employeeList: [],
  updateRes: [],
  deleteRes: [],
  loginRes: [],
  skipLocationRes: [],
  participantList: [],
  notifications: [],
  notRes: [],
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ADMIN_SWITCH_ACCOUNT_SUCCESS:
      return {
        ...state,
        success: action.payload,
      };
    case ADD_ADMIN_SWITCH_ACCOUNT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_USER_DATA_SUCCESS:
      if (action?.payload?.status) {
        localStorage.setItem("timezone", JSON.stringify(action?.payload?.time_zone));
        localStorage.setItem("pro_pic", JSON.stringify(action?.payload?.profile_pic_path));
        localStorage.setItem("company_logo", JSON.stringify(action?.payload?.company_logo));
      }
      return {
        ...state,
        me: action.payload,
      };
    case FREE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notRes: action.payload,
      };
    case FREE_NOTIFICATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case NOTIFICATION_SUCCESS:
      return {
        ...state,
        notifications: action.payload,
      };
    case NOTIFICATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case SKIP_LOCATION_SUCCESS:
      return {
        ...state,
        skipLocationRes: action.payload,
      };
    case SKIP_LOCATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case AVAILABLE_LOCATIONS_SUCCESS:
      return {
        ...state,
        locationsList: action.payload,
      };
    case AVAILABLE_LOCATIONS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case LOGIN_AS_MANAGER_SUCCESS:
      return {
        ...state,
        loginRes: action.payload,
      };
    case LOGIN_AS_MANAGER_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case LOGIN_AS_ADMIN_SUCCESS:
      return {
        ...state,
        loginRes: action.payload,
      };
    case LOGIN_AS_ADMIN_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_LOCATION_SUCCESS:
      return {
        ...state,
        deleteRes: action.payload,
      };
    case DELETE_LOCATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_MANAGER_DETAILS_SUCCESS:
      return {
        ...state,
        updateRes: action.payload,
      };
    case UPDATE_MANAGER_DETAILS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case GET_EMPLOYEE_BY_LOCATION_SUCCESS:
      return {
        ...state,
        employeeList: action.payload,
      };
    case GET_EMPLOYEE_BY_LOCATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case GET_PARTICIPANT_BY_LOCATION_SUCCESS:
      return {
        ...state,
        participantList: action.payload,
      };
    case GET_PARTICIPANT_BY_LOCATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case GET_MANAGER_BY_ID_SUCCESS:
      return {
        ...state,
        managerDetails: action.payload,
      };
    case GET_MANAGER_BY_ID_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case ASSIGN_LOCATION_SUCCESS:
      return {
        ...state,
        assignRes: action.payload,
      };
    case ASSIGN_LOCATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case MANAGER_LIST_SUCCESS:
      return {
        ...state,
        managerList: action.payload,
      };
    case MANAGER_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case LOCATION_LIST_SUCCESS:
      return {
        ...state,
        locationList: action.payload,
      };
    case LOCATION_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_LOCATION_SUCCESS:
      return {
        ...state,
        response: action.payload,
      };
    case ADD_LOCATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case EDIT_COMPANY:
      state = { ...state };
      break;
    case EDIT_COMPANY_SUCCESS:
      state = { ...state, success: action.payload };
      break;
    case EDIT_COMPANY_ERROR:
      state = { ...state, error: action.payload };
      break;
    case EDIT_PROFILE:
      state = { ...state };
      break;
    case PROFILE_SUCCESS:
      state = { ...state, success: action.payload };
      break;
    case PROFILE_ERROR:
      state = { ...state, error: action.payload };
      break;
    case RESET_PROFILE_FLAG:
      state = { ...state, success: null };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default profile;
